// extracted by mini-css-extract-plugin
export default {"container":"ConfirmCancel_container__7aTnH"};